import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = () => setMenuOpen((open) => !open);
  const handleLinkClick = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={handleLinkClick}>
          <img
            src={`${process.env.PUBLIC_URL}/shoplogo-white.png`}
            alt=""
            className="navbar-logo-img"
            decoding="async"
          />
          <h1>Advanced Metal Shop Ltd.</h1>
        </Link>
        <button
          className={`hamburger${menuOpen ? ' open' : ''}`}
          aria-label="Toggle navigation menu"
          onClick={handleMenuToggle}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
        <ul className={`nav-menu${menuOpen ? ' show' : ''}`}>
          <li className="nav-item">
            <Link to="/" className={`nav-link${location.pathname === '/' ? ' active' : ''}`} onClick={handleLinkClick}>Home</Link>
          </li>
          <li className="nav-item">
            <Link to="/about" className={`nav-link${location.pathname === '/about' ? ' active' : ''}`} onClick={handleLinkClick}>About Us</Link>
          </li>
          <li className="nav-item">
            <Link to="/services" className={`nav-link${location.pathname === '/services' ? ' active' : ''}`} onClick={handleLinkClick}>Services</Link>
          </li>
          <li className="nav-item">
            <Link
              to="/portfolio"
              className={`nav-link${location.pathname === '/portfolio' || location.pathname.startsWith('/projects/') ? ' active' : ''}`}
              onClick={handleLinkClick}
            >
              Projects
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/contact" className={`nav-link${location.pathname === '/contact' ? ' active' : ''}`} onClick={handleLinkClick}>Contact</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar; 